import * as XLSX from "xlsx";
import {
  IMPROVE_EXPORT_COLS,
  ImproveAreaExportData,
  ImproveExportFieldVisibility,
  ImproveExportOptions,
  fullImproveExportFieldVisibility,
} from "./types";
import {
  buildImproveExportDataRows,
  buildImproveExportHeader,
} from "./improveExportHelpers";

function buildSheet(
  areas: ImproveAreaExportData[],
  vis: ImproveExportFieldVisibility
): XLSX.WorkSheet {
  const templates = areas.map((a) => a.template);
  const header = buildImproveExportHeader(vis, templates);
  if (header.length === 0) {
    throw new Error("No export columns selected.");
  }
  const dataRows = buildImproveExportDataRows(areas, vis);
  const rows: (string | number)[][] = [header, ...dataRows];
  return XLSX.utils.aoa_to_sheet(rows);
}

export async function improveXlsxExporter(
  areas: ImproveAreaExportData[],
  _baseFilename: string,
  options?: ImproveExportOptions
): Promise<Blob> {
  if (areas.length === 0) {
    throw new Error("No areas to export.");
  }

  const vis = fullImproveExportFieldVisibility(options?.fieldVisibility);
  if (!IMPROVE_EXPORT_COLS.some((k) => vis[k] === true)) {
    throw new Error("No export columns selected.");
  }

  const wb = XLSX.utils.book_new();
  const ws = buildSheet(areas, vis);
  XLSX.utils.book_append_sheet(wb, ws, "Export");

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" }) as ArrayBuffer;
  return new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}
